import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  EtherScanPictogram,
  Flex,
  useTableProps,
  CryptoIcon,
  Heading,
  CurrencyValue,
  DataTable,
  RelativeDateTime
} from '@blockanalitica/ui';

export default function HolderEventsTable({ address, walletAddress, symbol }) {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: `/tokens/${address}/holders/${walletAddress}/events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Event',
        getCell: (row) => row.event
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Amount
            <CryptoIcon name={symbol} address={address} size="0" />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue value={row.amount} options={{ trend: true }} />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'amount'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap={['xs', '2xs']} color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'order_index'
      }
    ];

    return (
      <>
        <Heading size="2">Events</Heading>
        <DataTable
          rows={data['results']}
          columns={columns}
          getKey={(row) => row.order_index}
          sorting={sorting}
          pagination={{
            ...pagination,
            totalRecords: data.count
          }}
        />
      </>
    );
  }
  return <TableSkeleton />;
}
